import { API } from "../lib/api";
import { AuthChangeEmailBody, AuthChangePasswordBody, AuthVerifyEmailBody, SyncJobStatus, UserResponse } from "@boxem/core-api-schema";

export function sendAuthCode(payload: { code: string; sellerId: string; redirectUri: string }) {
  return API.post<{
    sellerId?: string,
    listingSyncStatus?: SyncJobStatus,
    shipmentSyncStatus?: SyncJobStatus, 
    //shipmentItemSyncStatus?: SyncJobStatus,
    //shipmentTransportSyncStatus?: SyncJobStatus
  }>("/auth/connect/seller-central", payload, null);
};

export function disconnectSellerAccount() {
  return API.patch<UserResponse>(`/auth/disconnect/seller-central`);
};

export function verifyEmail(payload: AuthVerifyEmailBody) {
  return fetch(`${process.env.PUBLIC_API_URL}/auth/verify-email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
};

export function verifyOTP(otp: string) {
  return API.post("/auth/verify-otp", { otp });
}

export function resendVerifyEmail() {
  return API.post("/auth/resend-email-verification");
};

export function getMe() {
  return API.get("/auth/me");
};

export function changeEmail(body: AuthChangeEmailBody) {
  return API.post("/auth/change-email", body);
}

export function changePassword(body: AuthChangePasswordBody) {
  return API.post("/auth/change-password", body);
}

export function changeName(newName: string) {
  return API.post("/auth/change-name", { name: newName });
}

export function startSession() {
  return API.patch("/auth/session/start");
}

//End session uses keepalive true on request to ensure API call can still be made after user closes tab.
export function endSession() {
  return API.patch("/auth/session/end", null, null, true);
}
